/*
Monotype Foundry Platform API
Version 1.0.0

Definition: JwtSigningPayload

Properties:
  data: object (required)
*/

var JwtSigningPayload = (function () {
  function validateJwtSigningPayload (arg) {
    // Validate data
    if (!arg.data) {
      throw new Error('JwtSigningPayload.data: Missing property')
    }
    if (arg.data && !(typeof arg.data === 'object')) {
      throw new Error('JwtSigningPayload.data: Wrong type: Got \'' + (typeof arg.data) + '\', but expected: \'object\'')
    }
  }
  function buildJwtSigningPayload (arg) {
    var JwtSigningPayload = arg
    // Complete data
    // Expected Type: object
    JwtSigningPayload.data = JwtSigningPayload.data || {}
    return JwtSigningPayload
  }
  return {
    validate: validateJwtSigningPayload,
    build: buildJwtSigningPayload
  }
})()

module.exports = JwtSigningPayload
